<template>
    <vx-card no-shadow card-border>

        <div class="mb-base">
            <h6 class="mb-4">ACTIVIDADES</h6>

            <div class="flex items-center mb-4">
                <vs-switch v-model="enviarCorreo" />
                <span class="ml-4">Enviar correo cuando el registro de actividades es vacio o incompleta</span>
            </div>
        </div>

        <div>
            <h6 class="mb-4">APLICACION</h6>

            <div class="flex items-center mb-4">
                <vs-switch v-model="actividad" />
                <span class="ml-4">Actividad no registrada o incompleta.</span>
            </div>
            <div class="flex items-center mb-4">
                <vs-switch v-model="reportes" />
                <span class="ml-4">Reporte de problemas frecuentes</span>
            </div>
        </div>

        <div class="flex flex-wrap items-center justify-end mt-base">
            <vs-button class="ml-auto mt-2" icon-pack="feather" icon="icon-save">Guardar</vs-button>
            <vs-button @click="limpiar" class="ml-4 mt-2" icon-pack="feather" type="border" icon="icon-trash" color="warning">Limpiar</vs-button>
        </div>

    </vx-card>
</template>
<script>
export default {
    data () {
        return {
            enviarCorreo: true,
            actividad: true,
            reportes: false,
        }
    },
    computed: {
        activeUserInfo () {
            return this.$store.state.AppActiveUser
        }
    },

    methods: {
        limpiar(){
            this.enviarCorreo = false;
            this.actividad = false;
            this.reportes = false;
        }
    }
}
</script>